import React, { useEffect, useState } from "react";
import { fechaActual } from "../../../hooks/UseDate";
import { postQuirofanosFarmacia } from "../../../services/FarmaciaRuta";
import { postLiquidacionQx } from "../../../services/PaginaRuta";
import ModalLiquidacionProcedimientoCirugia from "./ModalLiquidacionProcedimientoCirugia";
import TablaLiquidacionQx from "./TablaLiquidacionQx";
import Loading from "../../Loading";
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { UserTokenURL } from "../../../services/ApiHIS";



const LiquidacionQx = () => {
    const [modalOnLiquidacion, setmodalOnLiquidacion]=useState(false)
    const [dataLiquidacion, setdataLiquidacion]=useState([])
    const [dataQuirofanos, setdataQuirofanos] = useState([]);
    const [loading,setloading] = useState(false)
    const [actualizarDataLiquidacion, setactualizarDataLiquidacion]=useState([])
    const handleOnclickLiquidacion=()=>{
        setmodalOnLiquidacion(true)
    }

    //token
  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get('token'));
  let location = useLocation();
  useEffect(() => {
    // Google Analytics
    //localStorage.removeItem('tokenReact');
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

    useEffect(()=>{
      const quirofanos = {
        EMPCOD: "1",
        ConsTpo: "QR",
        MCDpto: "001",
      };
      postQuirofanosFarmacia(quirofanos).then((res)=>{
        setdataQuirofanos(res.data)
      })
    },[])

    
    useEffect(()=>{
      setloading(false)
      const liquidacion={
        MPNOMC:'',
        ProFec: fechaActual(),///'2023-01-30',
        ProEmpCod:'1',
        ProSedQr:'001',
        MPCedu:''
        //ProCons:'',
        //ProEsta:''
      }
      postLiquidacionQx(liquidacion).then((res)=>{
        // console.log(Object.values(res.data),'data')
        console.log(Object.prototype.toString.call(res.data), ' data'); // Output: "[object Array]"

        let dataLiquidacionUser = Object.values(res.data)
        let dataLiquidacionEstadoCirugia = dataLiquidacionUser.filter((res)=>res.ultimoEstado === "salida")
        setdataLiquidacion(dataLiquidacionEstadoCirugia)
        setloading(true)
      })
      .catch(error => {
        //console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true)
        setloading(true)
      });
    },[actualizarDataLiquidacion])

    const handleOnSumitBuscar=(e)=>{
      e.preventDefault();
      setloading(false)
      //console.log(e.target.fechab.value,'data')
      const liquidacion={
        MPNOMC: e.target.nombre.value,
        ProFec: e.target.fechab.value,//fechaActual(),///'2023-01-30',
        ProEmpCod:'1',
        ProSedQr:'001',
        //ProEsta:e.target.estadosSelect.value,
        ProCons: e.target.quirofanoSelect.value,
        MPCedu: e.target.cedula.value
      }
      postLiquidacionQx(liquidacion).then((res)=>{
        console.log(Object.values(res.data),'dataaa')
        let dataLiquidacionUser = Object.values(res.data)
        let dataLiquidacionEstadoCirugia = dataLiquidacionUser.filter((res)=>res.ultimoEstado === "salida")
        setdataLiquidacion(dataLiquidacionEstadoCirugia)
        setloading(true)
      })
      .catch(error => {
        //console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true)
        setloading(true)
      });
    }

    //token
    useEffect(()=>{
      //console.log(tokenCons,'tokenConstokenCons')
      const url = UserTokenURL() 
  
      // Configurar la cabecera con el token JWT
      const headers = {
        Authorization: `Bearer ${tokenCons}`,
      };
  
      // Realiza la petición con Axios
      axios.get(url, { headers })
      .then(response => {
        //console.log(response.data.user_data, 'data user');
  
        // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
        localStorage.removeItem('usuarioInfo');
        console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
        // Guarda los nuevos datos
        localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));
  
        //console.log(localStorage.getItem('usuarioInfo'),'antessss')
        // Comprobación de los datos almacenados
        const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
        //console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr hoja')
  
        // Resto del código...
      })
      .catch(error => {
        console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true)
      });
    },[])
  return (
    <div>
      <div className="text-2xl text-[#9e56fe] font-medium">
        Liquidación procedimiento Cirugía
      </div>
      <div className="text-center bg-[#9e56fe] pb-1 my-4">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
            >
              Filtros de Búsqueda
            </label>
          </div>
      <form onSubmit={handleOnSumitBuscar}>
      <div className="flex ">
      <div className="mb-1 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Número Sala
              </label>

              <select
                //disabled={true}
                name="quirofanoSelect"
                className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                aria-label="Default select example"
              >
                <option value=''>TODOS</option>
                {dataQuirofanos.map((item) => (
                  <option value={item.ConsCod} key={item.ConsCod}>
                    {item.ConsDet}
                  </option>
                ))}
              </select>
            </div>
        <div className="mb-3 pl-1">
          <label
            htmlFor="exampleFormControlInput1"
            className="form-label inline-block mb-2 text-gray-900 font-medium"
          >
            Fecha
          </label>
          <div className="flex">
            <div className="flex items-center justify-center">
              <div className="datepicker relative form-floating mb-3 xl:w-96">
                <input
                  defaultValue={fechaActual()}
                  type="date"
                  name="fechab"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  placeholder="Select a date"
                />
              </div>
            </div>

            
          </div>
        </div>
      </div>
      <div className="flex ">
        <div className="mb-1 xl:w-96">
          <label
            htmlFor="exampleFormControlInput1"
            className="form-label inline-block mb-2 text-gray-900 font-medium"
          >
            Nombre Paciente
          </label>
          <div className="flex">
            <input
              name="nombre"
              type="text"
              autoComplete="off"
              className="form-control block  w-full px-2 py-0.5 text-base font-normal  text-gray-900 bg-[#eaebec] bg-clip-padding border border-solid border-gray-300
                          rounded transition  ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              id="exampleFormControlInput1"
              placeholder=""
            />
           
          </div>
          
        </div>
        <div className="mb-1 xl:w-96 px-2">
          <label
            htmlFor="exampleFormControlInput1"
            className="form-label inline-block mb-2 text-gray-900 font-medium"
          >
            Numero documento
          </label>
          <div className="flex">
            <input
              name="cedula"
              type="text"
              autoComplete="off"
              className="form-control block  w-full px-2 py-0.5 text-base font-normal  text-gray-900 bg-[#eaebec] bg-clip-padding border border-solid border-gray-300
                          rounded transition  ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              id="exampleFormControlInput1"
              placeholder=""
            />
            <div className="px-3">
              <button
              //onClick={handleOnclickLiquidacion}
                type="submit"
                className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              >
                Buscar
              </button>
            </div>
          </div>
          
        </div>
        
      </div>
      </form>
      <div className="flex flex-col">
        <div className="overflow-x-auto  ">
          <div className="py-4 inline-block min-w-full">
            <div className="overflow-hidden">
              <table className="min-w-full text-center bg-gray-200">
                <thead className=" ">
                  <tr>
                  <th
                      scope="col"
                      className="text-sm font-medium text-gray-900"
                    >
                      
                    </th>
                  <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      
                    </th>
                  <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      Fecha
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      Cd. Sala
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      Sala
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      Documento
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      Id Paciente
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      Nombre Paciente
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      Hora Ini.
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      Hora Fin.
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      Estado
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-2 py-2"
                    >
                      C. Costo
                    </th>
                    
                  </tr>
                </thead>
                {
                  loading?
                  dataLiquidacion.map((item,index)=>(
                    <TablaLiquidacionQx item={item} key={index} setactualizarDataLiquidacion={setactualizarDataLiquidacion}/>
                  ))
                  :
                  <tbody className="divide-y divide-slate-700">
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><Loading/></td>
                    </tr>
                    </tbody>
                }
                  
                  {/* {
                    loading?
                    dataDescripcionQuirurgica.map((item,index)=>(
                      <TablaDescripcionQuirurgicaDQ key={index} item={item}/>
                    ))
                    :
                    
                  } */}
                
              </table>
            </div>
          </div>
        </div>
      </div>
      {modalOnLiquidacion? <ModalLiquidacionProcedimientoCirugia setmodalOnLiquidacion={setmodalOnLiquidacion}/>:null}
    </div>
  );
};

export default LiquidacionQx;
